import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {MODULE, PageProps, SECURABLE} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";
import mdEntityService from "core/metamodel/mdEntityService";


const gridLocationMap = {
  Country: "countryList"
};

@observer
export default class ReferenceDetail extends PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static icon = 'server';
  static protectedPage = true;


  static fetchData(routerParams) {

    const gridLocation = gridLocationMap[routerParams.id];

    document.title = 'Reference Table - ' + routerParams.id;

    console.log("ReferenceDetail#fetchData(%s)", gridLocation);
    return gridService.fetchGrids(gridLocation)
      .then(gl => gridService.getOrCreateGrid(gridLocation));
  }


  render() {
    let {params, query} = this.props;

    const gridLocation = gridLocationMap[params.id];

    return (
        <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query}/>
    );
  }


}



// WEBPACK FOOTER //
// ./src/administration/referenceTables/referenceDetail.tsx